module.exports = __webpack_public_path__ + "img/laravel.0190d123.svg";